import { render, staticRenderFns } from "./PreviewDriverDocumentWidget.vue?vue&type=template&id=38e6546f&scoped=true&"
import script from "./PreviewDriverDocumentWidget.vue?vue&type=script&lang=js&"
export * from "./PreviewDriverDocumentWidget.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDriverDocumentWidget.vue?vue&type=style&index=0&id=38e6546f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6546f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e6546f')) {
      api.createRecord('38e6546f', component.options)
    } else {
      api.reload('38e6546f', component.options)
    }
    module.hot.accept("./PreviewDriverDocumentWidget.vue?vue&type=template&id=38e6546f&scoped=true&", function () {
      api.rerender('38e6546f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/PreviewDriverDocumentWidget.vue"
export default component.exports